export default __webpack_public_path__ + "media/images/rails-9c0a079bdd7701d7e729bd956823d153.png";